import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
// sub pages
import PersonalizePage from './personalize/PersonalizePage';
import { Page404, Construction } from 'pages/errors';
import PrintPage from './print/PrintPage';
import TasksPage from './tasks/TasksPage';
import MarkPage from './mark';
import TasksAccomplished from './streaks/TasksAccomplished';
import Streaks from './streaks/Streaks';
import DuchPage from './duch/DuchPage';
// functions
import { isBC } from 'functions/login';

export class MissionsIndexPage extends Component {

  render() {
    const { code } = this.props.login;
    const { path } = this.props.match;

    return (
      <Switch>
        <Route path={`${path}/print`}       component={ PrintPage } />
        <Route path={`${path}/mark`}        component={ MarkPage } />
        <Route path={`${path}/personalize`} component={ PersonalizePage } />
        <Route path={`${path}/tasks-accomplished`} component={ TasksAccomplished } />
        <Route path={`${path}/streaks`}     component={ Streaks } />
        <Route path={`${path}/duch`}        component={ DuchPage } />
        <Route path={`${path}/report`}      component={ Construction } />

        { isBC( code ) &&
          <Route path={`${path}/tasks`}     component={ TasksPage } /> }

        <Route component={ Page404 } />
      </Switch>
    )
  }
}

const mapStateToProps = ({ login }) => ({
  login: login.current_login
})

export default connect( mapStateToProps )( MissionsIndexPage );



// WEBPACK FOOTER //
// ./src/pages/missions/index.jsx